import React from "react";
import Swal from "sweetalert2";
import { createClientTestimonial } from "../../api/ClientTestimonial";
import { useState } from "react";

const CreateClientTestimonial = ({ onSuccess }) => {
  const [clientTestimonial, setClientTestimonial] = useState({
    name: "",
    rating: "",
    message: "",
  });

  // state for image upload
  const [file, setFile] = useState(null);
  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleChange = (e) => {
    setClientTestimonial({
      ...clientTestimonial,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", file);
    Object.entries(clientTestimonial).forEach(([key, value]) =>
      formData.append(key, value)
    );
    const response = createClientTestimonial(formData);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Client Testimonial Created!",
            text: "You have successfully created a client testimonial!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputName">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputIntroduction">Rating</label>
          <div class="starrating risingstar d-flex justify-content-end flex-row-reverse">
            <input
              type="radio"
              id="star5"
              name="rating"
              value="5"
              onChange={handleChange}
            />
            <label for="star5" title="5 star">
              5
            </label>
            <input
              type="radio"
              id="star4"
              name="rating"
              value="4"
              onChange={handleChange}
            />
            <label for="star4" title="4 star">
              4
            </label>
            <input
              type="radio"
              id="star3"
              name="rating"
              value="3"
              onChange={handleChange}
            />
            <label for="star3" title="3 star">
              3
            </label>
            <input
              type="radio"
              id="star2"
              name="rating"
              value="2"
              onChange={handleChange}
            />
            <label for="star2" title="2 star">
              2
            </label>
            <input
              type="radio"
              id="star1"
              name="rating"
              value="1"
              onChange={handleChange}
            />
            <label for="star1" title="1 star">
              1
            </label>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputImage">Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            onChange={handleFileChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputMessage">Message</label>
          <textarea
            className="form-control"
            id="exampleInputMessage"
            rows="3"
            name="message"
            onChange={handleChange}
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default CreateClientTestimonial;
